export default __webpack_public_path__ + "static/media/ok_icon.ca096e0b.svg";